export const language = {
  en: 'English',
  'zh-TW': 'Traditional Chinese',
  zh_TW: 'Traditional Chinese',
  zh_CN: 'Simplified Chinese',
};